// extracted by mini-css-extract-plugin
export default {"wrapper":"TableAutoComponent_wrapper__kVufm"};